<script lang="ts">
	import VerivoxSetupBanner from './internal/VerivoxSetupBanner.svelte';
	import type { VerivoxDismissSurface } from '../utils/verivoxDismissals';

	/** Verivox setup promo for the Notifications dropdown (full chrome). */
	export let onCtaClick: () => void;
	export let dismissable = false;
	export let dismissSurface: VerivoxDismissSurface = 'notifications';
	export let onDismiss: (() => void) | undefined;
</script>

<VerivoxSetupBanner layout="notifications" {onCtaClick} {dismissable} {dismissSurface} {onDismiss} />
